import { useState, useEffect } from "react";
import { Column, ReportPrintComponent, Row } from "./styled";
import CardGraphic from "../CardGraphic";
import GraphicRadar from "../GraphicRadar";
import Map from "../Map";
import logo_image from "../../../assets/logo_tau.png";
import logo_jonnpo_image from "../../../assets/logo_jonnpo.png";
import AssetInformation from "../AssetInformation";
import GraphicStatus from "../GraphicStatus";
import { useReportPrintHook } from "./hook";
import GraphicDegradation from "../GraphicDegradation";
import GraphicQuantitativeSmall from "../GraphicQuantitativeSmall";
import { LineChartComponent } from "../LineChart";
import { baseUrl } from "../../../service/api";
import { GraphicContainer } from "../CardGraphic/styled";

import card_1_icon from "../../../assets/icons/card-1.svg";
import card_2_icon from "../../../assets/icons/card-2.svg";
import card_3_icon from "../../../assets/icons/card-3.svg";
import card_4_icon from "../../../assets/icons/card-4.svg";
import { convertNumberBR } from "../../../utils/functions";
import { Loading } from "../Loading";

const ReportPrintPage = () => {
  const hook = useReportPrintHook();
  return (
    <>
      {hook.general.showData ? (
        <ReportPrintComponent>
          <div className="sec1">
            <div className="sec1-1">
              <div className="item">
                <span className="title">Dados de cadastro</span>
                <div className="card">
                  <span>Ativo</span>
                  <span className="value">
                    {hook.selectdAsset.assetData?.name}
                  </span>
                </div>

                <div className="card">
                  <span>Grupo</span>
                  <span className="value">
                    {hook.selectdAsset.assetData?.group?.name}
                  </span>
                </div>

                <div className="card">
                  <span>Unidade</span>
                  <span className="value">
                    {hook.selectdAsset.assetData?.unit?.name}
                  </span>
                </div>

                <div className="card">
                  <span>Processo</span>
                  <span className="value">
                    {hook.selectdAsset.assetData?.unit?.process}
                  </span>
                </div>

                <div className="card">
                  <span>Subprocesso</span>
                  <span className="value">
                    {hook.selectdAsset.assetData?.unit?.subprocess}
                  </span>
                </div>

                <div className="card">
                  <span>Quantidade de seções</span>
                  <span className="value">
                    {hook.selectdAsset.assetData?.sections?.length}
                  </span>
                </div>
              </div>

              <div className="item">
                <span className="title">Resumo do ativo</span>
                <div className="card">
                  <span>Área total</span>
                  <span className="value">
                    {hook.assets.metricsData?.status?.totalArea}
                  </span>
                </div>

                <div className="card">
                  <span>Área total degradada</span>
                  <span className="value">
                    {hook.assets.metricsData?.status.totalDegradedArea}
                  </span>
                </div>

                <div className="card">
                  <span>Quantidade de anomalias</span>
                  <span className="value">
                    {hook.anomalies.anomaliesData?.count}
                  </span>
                </div>
              </div>
            </div>

            <div className="sec1-2">
              <div className="empresas">
                <div className="empresas-item">
                  <div className="logo-tau">
                    <img src={logo_image} alt="logo" />
                  </div>
                  <span>Gestão de ativos</span>
                  <span>123456.0001/01</span>
                </div>
                <div className="empresas-item">
                  <div className="logo-jonnpo">
                    <img src={logo_jonnpo_image} alt="logo" />
                  </div>
                  <span>Jonnpo Tecnologia</span>
                  <span>123456.0001/01</span>
                </div>
              </div>

              <div className="graficos">
                <div className="radar">
                  <CardGraphic
                    graphic={
                      <GraphicRadar
                        config={[
                          {
                            label: "Falha geral",
                            color: "RGBA(168, 168, 168, 0.2)",
                            borderColor: "#A8A8A8",
                          },
                          {
                            label: "Seleção",
                            color: "RGBA(255, 0, 0, 0.4)",
                            borderColor: "#FF0000",
                          },
                        ]}
                        datasets={[
                          {
                            data: hook.defectTypes.metricsData?.generalSeries.map(
                              (e) => e.value
                            ),
                          },
                          {
                            data: hook.defectTypes.metricsData?.selectedSeries.map(
                              (e) => e.value
                            ),
                          },
                        ]}
                        labels={hook.defectTypes.metricsData?.seriesNames}
                      />
                    }
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="sec2">
            {!hook.assets.isLoading && (
              <Column>
                <Row className="full border">
                  <div className="width-20">
                    <AssetInformation
                      asset={hook.selectdAsset?.assetData}
                      reports={true}
                    />
                  </div>

                  <div className="width-20">
                    <CardGraphic
                      reports={true}
                      title={`Status do Ativo (m²)`}
                      footer={{
                        description: "Área Total",
                        value: hook.assets.metricsData?.status.totalArea,
                      }}
                      graphic={
                        <GraphicStatus
                          isLoading={false}
                          data={hook.assets.metricsData?.status}
                        />
                      }
                    />
                  </div>

                  <div className="width-20">
                    <CardGraphic
                      title={"Degradação de RI's (m²)"}
                      footer={{
                        description: "Áreas em RI",
                        value:
                          hook.assets.metricsData?.status.totalDegradedArea,
                      }}
                      graphic={
                        <GraphicDegradation
                          data={{
                            total:
                              hook.assets.metricsData?.status.totalDegradedArea,
                            ris: hook.assets.metricsData.degradationRis?.ris?.map(
                              (e) => ({
                                label: e.label,
                                totalArea: e.totalArea,
                              })
                            ),
                          }}
                        />
                      }
                    />
                  </div>

                  <div className="width-40">
                    <CardGraphic
                      title={"Projeção de Vencimento (m²)"}
                      graphic={
                        <LineChartComponent
                          width={"100%"}
                          height={130}
                          {...hook.assets.getChartdata(hook.assets.metricsData)}
                          isLoading={hook.assets.isLoading}
                        />
                      }
                    />
                  </div>
                </Row>

                <GraphicContainer>
                  <Column className="mt">
                    <Row>
                      <GraphicQuantitativeSmall
                        title={{
                          description: "Taxa de renovação - Teórico",
                          color: "#292929",
                        }}
                        icon={card_4_icon}
                        subtitle={{
                          value: convertNumberBR(
                            hook.single.metricsData?.renovation
                              ?.weightedAverageTeorical
                          ),
                          description: "m²/ano",
                          color: "#FF3131",
                        }}
                      />
                      <GraphicQuantitativeSmall
                        title={{
                          description: "Taxa de renovação - Real",
                          color: "#292929",
                        }}
                        icon={card_3_icon}
                        subtitle={{
                          value: convertNumberBR(
                            hook.single.metricsData?.renovation
                              ?.weightedAverageReal
                          ),
                          description: "m²/ano",
                          color: "#FF3131",
                        }}
                      />
                    </Row>

                    <Row>
                      <GraphicQuantitativeSmall
                        title={{
                          description: "Vida útil média da pintura",
                          color: "#292929",
                        }}
                        icon={card_1_icon}
                        subtitle={{
                          value: convertNumberBR(
                            hook.single.metricsData?.renovation?.averageLifetime
                          ),
                          description: "anos",
                          color: "#FF3131",
                        }}
                      />
                      {!hook.single.isLoading &&
                      hook.single.metricsData?.corrosivities ? (
                        <GraphicQuantitativeSmall
                          title={{
                            description: "Corrosividade",
                            color: "#292929",
                          }}
                          icon={card_2_icon}
                          subtitle={{
                            value:
                              hook.single.metricsData?.corrosivities.length > 0
                                ? hook.single.metricsData?.corrosivities[0]
                                    ?.corrosivity
                                : "N/A",
                            description: "",
                            color: "#FF3131",
                          }}
                        />
                      ) : (
                        <></>
                      )}
                    </Row>
                  </Column>
                </GraphicContainer>
              </Column>
            )}
          </div>

          <div className="sec3">
            <span className="title">Registros</span>
            {hook.anomalies.anomaliesData?.rows?.map((anomalie) => (
              <div className="anomalie-container" key={anomalie.id}>
                <span className="title-small">
                  {anomalie.section?.asset?.name}
                </span>
                <span>{anomalie.section?.name}</span>

                <div className="anomalie-info">
                  <div className="anomalie-details">
                    <div className="anomalie-details-item">
                      <span className="title-small">Seção</span>
                      <span>{anomalie.section?.name}</span>
                    </div>
                    <div className="anomalie-details-item">
                      <span className="title-small">Tipo</span>
                      <span>{anomalie.defectType?.name}</span>
                    </div>
                    <div className="anomalie-details-item">
                      <span className="title-small">Grau de degradação</span>
                      <span>{anomalie.degradationDegree?.name}</span>
                    </div>
                    <div className="anomalie-details-item">
                      <span className="title-small">Área</span>
                      <span>{anomalie.area}</span>
                    </div>
                  </div>
                  <div className="anomlie-images">
                    {anomalie.medias?.map((media) => (
                      <img
                        key={media.id}
                        src={`${baseUrl}/${media.path}`}
                        alt="Imagem não encontrada"
                      />
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </ReportPrintComponent>
      ) : (
        <div className="loading">
        <Loading/>
        </div>
      )}
    </>
  );
};

export default ReportPrintPage;
